/**
 * @file  Annual
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */
import React, {useEffect, useState, useContext} from 'react';
import {Table, message, Pagination, Button, Divider} from 'antd';
import Iconfont from '~/component/Iconfont';
import {DEFAULT_PAGE_NUM, DEFAULT_PAGE_SIZE} from '~/utils/http';
import {getListByChannelCode} from '~/service/cms';
import {BasicLayoutContext} from '~/layout/BasicLayout';

import './index.less';

const columns = [
    {
        title: 'Year',
        dataIndex: 'year',
        width: 208,
    },
    {
        title: 'Title',
        dataIndex: 'title',
        render: (title, record) => (
            <>
                <div>
                    {title}
                </div>
                <a href={record.earningsRelease.url} target="_blank">
                    <Button
                        icon={<Iconfont type="iconxiazai" className="iconxiazai" />}
                    >
                        Download
                    </Button>
                </a>
            </>
        )
    }
];

const columnsMobile = [
    {
        title: 'Year',
        dataIndex: 'year',
        width: 120,
    },
    {
        title: 'Title',
        dataIndex: 'title',
    },
    {
        title: 'Download',
        width: 100,
        render: (title, record) => (
            <>
                <a href={record.earningsRelease.url} target="_blank">
                    <Button
                        type="text"
                        icon={<Iconfont type="iconxiazai" className="iconxiazai-mobile" />}
                    />
                </a>
            </>
        )
    }
];

function Annual() {
    const [list, setList] = useState([]);
    const [total, setTotal] = useState(0);
    const layoutContext = useContext(BasicLayoutContext);
    const {isMobile} = layoutContext ?? {};

    const [pageDto, setPageDto] = useState({
        pageNum: DEFAULT_PAGE_NUM,
        pageSize: DEFAULT_PAGE_SIZE
    });
    const {pageNum} = pageDto;

    function handlePageChange(page, pageSize) {
        setPageDto({
            pageNum: page,
            pageSize
        });
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        getListByChannelCode({code: 'channel_ir_ndbg', pageDto})
            .then(({data: {list, total}}) => {
                setList(list.map(({content: {title, year, earningsRelease}}) => ({title, year, earningsRelease})));
                setTotal(total);
            })
            .catch(() => {
                message.error('获取分页列表信息失败');
            });
    }, [pageDto]);


    return (
        <div className="annual-container">
            {
                isMobile && (
                    <>
                        <div className="annual-container-title">
                            Annual Reports
                        </div>
                        <Divider />
                    </>
                )
            }
            <Table columns={isMobile ? columnsMobile : columns} dataSource={list} pagination={false} />

            <Pagination
                onChange={handlePageChange}
                defaultPageSize={20}
                defaultCurrent={1}
                total={total}
                current={pageNum}
                showSizeChanger
                hideOnSinglePage
                // eslint-disable-next-line react/jsx-no-bind
                showTotal={total => `Total Records: ${total} `}
            />
        </div>
    );
}

export default Annual;
